module.exports = __webpack_public_path__ + "img/enabled_selected.76a3220e.svg";